import React, { useEffect, useState } from 'react';
import AuthFunctions from './services/AuthService';
import Session from './auth/Session';
import { useNavigate } from 'react-router-dom';
import { Container, Card, CardBody } from "reactstrap";

function Home() {
    const navigate = useNavigate();
    const [authenticated, setAuthenticated] = useState(false);

    useEffect(() => {
        const check = async () => {
            const isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
            if (!isAuthenticated) {
                navigate('/logout');
                return;
            }
            setAuthenticated(true);
        };
        check();
    }, [navigate]);

    if (!authenticated) {
        return null;
    }

    const userName = Session.getUserName();

    return (
        <Container className="mt-4">
            <Card>
                <CardBody>
                    <h4>Welcome{userName ? `, ${userName}` : ''}</h4>
                    <p className="text-muted mb-0">Use the top menu to navigate to a page.</p>
                </CardBody>
            </Card>
        </Container>
    );
}

export default Home;
